import type { LevelBadge, LevelIcon } from '@workflow/contracts'
import { cn, Icons, type IconConcept } from '@workflow/ui'

/** Each mark a level may wear, bound to its glyph in the registry. */
export const LEVEL_GLYPH: Record<LevelIcon, IconConcept> = {
  sprout: 'levelSprout',
  star: 'levelStar',
  medal: 'levelMedal',
  award: 'levelAward',
  trophy: 'levelTrophy',
  crown: 'levelCrown',
  gem: 'levelGem',
  flame: 'levelFlame',
  rocket: 'levelRocket',
  shield: 'levelShield',
  zap: 'levelZap',
  mountain: 'levelMountain',
}

export function LevelGlyph({ icon, className }: { icon: LevelIcon; className?: string }) {
  const Glyph = Icons[LEVEL_GLYPH[icon]]
  return <Glyph size="sm" className={className} />
}

/**
 * A level as it is worn: the mark and the name, nothing else. There is
 * deliberately no tooltip — what a level carries is the studio's business,
 * not a hint on the player's page.
 */
export function LevelMark({ level, className }: { level: LevelBadge; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-1 whitespace-nowrap', className)}>
      <LevelGlyph icon={level.icon} />
      <span>{level.name}</span>
    </span>
  )
}
